var _rect, _style, _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExample1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 338 173",
    fill: "none",
    width: 338,
    height: 173,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 338,
    height: 173,
    fill: "#3A4149"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n                .st0 {\r\n                        display: none;\r\n                        fill: none;\r\n                        stroke: #FAF9F7;\r\n                        stroke-width: 2;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .st1 {\r\n                        fill: #6B9994;\r\n                }\r\n\r\n                .st2 {\r\n                        fill: #4CB0D3;\r\n                }\r\n\r\n                .st3 {\r\n                        fill: #FAF9F7;\r\n                }\r\n\r\n                .st4 {\r\n                        fill: #6B9994;\r\n                        stroke: #FAF9F7;\r\n                        stroke-width: 1.5;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .st5 {\r\n                        fill: none;\r\n                        stroke: #FAF9F7;\r\n                        stroke-width: 1.5;\r\n                        stroke-miterlimit: 10;\r\n                }\r\n\r\n                .st6 {\r\n                        stroke: #00AAE6;\r\n                        stroke-width: 2;\r\n                }\r\n\r\n                .st7 {\r\n                        fill: white;\r\n                        stroke: #00AAE6;\r\n                }\r\n\r\n                .st8 {\r\n                        fill: #000;\r\n                        fill-rule: evenodd;\r\n                }\r\n        ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car",
    transform: "translate(149,66.5) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,39.1H1.4v19c0,1.8,1.4,3.2,3.2,3.2H72c1.8,0,3.2-1.4,3.2-3.2L75.2,39.1L75.2,39.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.6,36.1 1.8,58.8 4.2,61 56.2,61 54.6,59 55,34.4 46.2,33.9 46.2,55 43.6,55.5 10.7,55.9 9.2,54.2  9.3,35  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.2,40.9H1.4v-19c0-1.8,1.4-3.2,3.2-3.2H72c1.8,0,3.2,1.4,3.2,3.2L75.2,40.9L75.2,40.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1.6,43.9 1.8,21.2 4.2,19 56.2,19 54.6,21 55,45.6 46.2,46.1 46.2,25 43.6,24.5 10.7,24.1 9.2,25.8  9.3,45  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,57.1h1.3c1.2,0,2.1-0.9,2.1-2.1v-2.9c0-1.2-0.9-2.1-2.1-2.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.8,61.5l-1.7,3.8c-0.7,1.5-2.4,2.1-3.9,1.5l-0.4-0.2l2.4-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.9,39.8v18c0,1.8,1.4,3.2,3.2,3.2H72c1.8,0,3.2-1.4,3.2-3.2v-18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "9.4,38.5 9.4,55.8 46.2,55.8 46.2,38.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.5,
    y1: 55.5,
    x2: 2.8,
    y2: 60.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 45.9,
    y1: 55.5,
    x2: 54.7,
    y2: 60.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.5,61.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 54.8,
    y1: 39.7,
    x2: 54.8,
    y2: 61.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 27.9,
    y1: 60.5,
    x2: 27.9,
    y2: 55.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 15.5,
    y1: 51.5,
    x2: 39.9,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 39.9,
    y1: 51.5,
    x2: 15.5,
    y2: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.2,22.9h1.3c1.2,0,2.1,0.9,2.1,2.1v2.9c0,1.2-0.9,2.1-2.1,2.1h-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.8,18.5l-1.7-3.8c-0.7-1.5-2.4-2.1-3.9-1.5l-0.4,0.2l2.4,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.9,40.2v-18c0-1.8,1.4-3.2,3.2-3.2H72c1.8,0,3.2,1.4,3.2,3.2v18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "9.4,41.5 9.4,24.2 46.2,24.2 46.2,41.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.5,
    y1: 24.5,
    x2: 2.8,
    y2: 19.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 45.9,
    y1: 24.5,
    x2: 54.7,
    y2: 19.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.5,18.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 54.8,
    y1: 40.3,
    x2: 54.8,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 27.9,
    y1: 19.5,
    x2: 27.9,
    y2: 24.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "marking"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    r: 7,
    cx: 171,
    cy: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 171,
    x2: 171,
    y1: 29,
    y2: 53,
    stroke: ""
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    width: 64,
    height: 64,
    x: 138,
    y: 52
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rotate-icon",
    transform: "translate(164,15) scale(0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.76,14.28c-2.12-4.77-7.08-8.15-12.59-8.15-7.61,0-13.75,6.14-13.75,13.75s6.14,13.75,13.75,13.75c3.19,0,6.13-1.08,8.46-2.89l-.92-1.18c-2.07,1.62-4.69,2.58-7.53,2.58-6.79,0-12.25-5.46-12.25-12.25S12.39,7.64,19.17,7.64c4.9,0,9.33,3.02,11.21,7.25l1.37-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.43,6.05l-1,7.7-7.7-1-.19,1.49,9.19,1.19,1.19-9.19-1.49-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M24.12,7.07c-4.87-1.87-10.75-.82-14.64,3.07-5.38,5.38-5.38,14.06,0,19.45,5.38,5.38,14.06,5.38,19.45,0,2.26-2.26,3.57-5.1,3.93-8.03l-1.49-.18c-.32,2.61-1.49,5.14-3.51,7.15-4.8,4.8-12.53,4.8-17.32,0-4.8-4.8-4.8-12.53,0-17.32,3.46-3.46,8.71-4.41,13.03-2.74l.55-1.39Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(187,100)",
    filter: "url(#filter0_d_3132_18962)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4009 27.1978L11.8178 25.2179C9.37123 23.8661 6.09269 24.6363 4.49072 26.9361L4.86399 26.4002C4.46643 26.9709 4.57574 27.811 5.10943 28.2747L11.6082 33.9214C12.6384 34.8166 14.5906 35.8205 15.9332 36.133C15.9332 36.133 23.8646 37.7819 24.7715 39.4946L25.9197 41.6628L34.8504 36.9335L37.2926 35.6402L39.3158 34.5688L41.5485 33.3865L40.4003 31.2183C39.4933 29.5056 40.0055 22.3274 40.0055 22.3274C40.0704 20.9505 39.609 18.8296 38.9596 17.6032L34.1835 8.5841C33.0857 6.60866 30.5333 5.88815 28.4414 6.99594C27.3949 7.55013 26.9757 8.80817 27.5047 9.80712L27.8872 10.5295C26.8298 8.53267 24.2775 7.81216 22.1856 8.91995C21.1391 9.47414 20.7199 10.7322 21.2489 11.7311L21.6314 12.4535C20.574 10.4567 18.0216 9.73618 15.9297 10.844C14.8832 11.3982 14.464 12.6562 14.993 13.6552L15.3756 14.3775C15.2056 14.0566 15.0363 13.8196 14.863 13.6525L9.3529 4.64438C8.6078 3.42625 7.0293 3.0092 5.79623 3.66218C4.55456 4.31971 4.09342 5.84511 4.74705 7.07941L9.48222 16.0212L15.4009 27.1978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09307 26.6591C3.89754 27.3901 4.12676 28.2157 4.7159 28.7276L11.2147 34.3744C12.3179 35.3329 14.3582 36.3824 15.7972 36.7174L15.8041 36.719L15.8111 36.7205L15.8112 36.7205L15.8121 36.7207L15.816 36.7215L15.8321 36.7249L15.8968 36.7387C15.9539 36.7509 16.0381 36.7691 16.146 36.793C16.3619 36.8408 16.6719 36.9112 17.047 37.001C17.7981 37.1807 18.8064 37.4375 19.8405 37.7465C20.8781 38.0565 21.9249 38.4141 22.7599 38.7932C23.1779 38.9829 23.5274 39.1711 23.7912 39.3527C24.0661 39.5419 24.1952 39.6883 24.2413 39.7754L25.3895 41.9436L25.6703 42.4738L26.2005 42.193L35.1312 37.4637L37.5733 36.1704L39.5966 35.099L41.8292 33.9167L42.3595 33.6359L42.0787 33.1057L40.9305 30.9375C40.7675 30.6297 40.6338 29.9747 40.5537 29.0545C40.4765 28.1675 40.4555 27.1308 40.4628 26.135C40.47 25.1414 40.5054 24.1992 40.539 23.5048C40.5557 23.1578 40.5721 22.8733 40.5842 22.6759C40.5902 22.5772 40.5952 22.5003 40.5987 22.4483L40.6026 22.3894L40.6037 22.3746L40.6039 22.3711L40.604 22.3703L40.604 22.3701L40.6045 22.3629L40.6048 22.3556C40.6405 21.5979 40.532 20.668 40.3364 19.7798C40.1409 18.892 39.8482 17.9991 39.4898 17.3224L34.7137 8.3033L34.7138 8.30324L34.7079 8.29264C33.4424 6.01537 30.5244 5.21393 28.1606 6.4657C27.3661 6.88645 26.8447 7.64037 26.7096 8.46116C25.3046 7.63236 23.479 7.55606 21.9048 8.38971C21.1102 8.81046 20.5889 9.56438 20.4538 10.3852C19.0488 9.55637 17.2232 9.48007 15.6489 10.3137C15.0558 10.6278 14.615 11.1275 14.3734 11.7021L9.86474 4.33129C8.95346 2.84149 7.02726 2.33134 5.51543 3.13194C3.97909 3.94552 3.40907 5.83489 4.21681 7.3602L8.95198 16.3019L13.9279 25.6984L12.108 24.6928C9.58283 23.2975 6.28153 23.9341 4.40161 26.0781L4.37166 26.0572L4.00067 26.5898C3.99991 26.5909 3.99915 26.592 3.99839 26.5931L4.09307 26.6591Z",
    stroke: "#363B3E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3132_18962",
    x: 0.250977,
    y: 0.155273,
    width: 45.9199,
    height: 47.1294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3132_18962"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3132_18962",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExample1);
export default __webpack_public_path__ + "static/media/example1.af18ca312b8c66aa51c2a430188d04ce.svg";
export { ForwardRef as ReactComponent };